import React from "react";
import { Icon } from "design-system/components/icon/icon";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import { LoadingSpinner } from "components/icons/loading-spinner";
import { PracticeStatus } from "services/api/practice/practiceService.types";
import { PracticeCardProps } from "./practice-card.types";
import {
  PracticeCardWrapper,
  LoadingContainer,
  PracticeCardContent,
  ContentImage,
  ContentText,
  TextTitle,
  TextDesc,
  ContentButtonGroup,
  ContentBadge,
  BadgeText
} from "./practice-card.styles";
import NotAvailImage from "public/assets-v2/illustrations/header_not_available.svg";
import NotStartImage from "public/assets-v2/illustrations/header_not_started.svg";
import OngoingImage from "public/assets-v2/illustrations/header_ongoing.svg";
import FinishImage from "public/assets-v2/illustrations/header_finished.svg";

const cardContent = (practiceStatus: PracticeStatus) => {
  switch (practiceStatus) {
    case "not_available":
      return {
        image: NotAvailImage,
        title: "Belum ada latihan untuk minggu ini",
        desc: "Tenang aja, nanti bakal ada lagi kok!",
        button: null,
        badge: null
      };
    case "not_started":
      return {
        image: NotStartImage,
        title: "Siap selesaikan latihan minggu ini?",
        desc: "Kumpulkan poin dan naikkan posisimu di leaderboard",
        button: "Latihan Sekarang",
        badge: "Dalam seminggu maksimal dapat 6 poin"
      };
    case "ongoing":
      return {
        image: OngoingImage,
        title: "Latihan mingguan belum selesai",
        desc: "Ayo jangan sampai ketinggalan dari teman-temanmu",
        button: "Lanjut Latihan",
        badge: "Dalam seminggu maksimal dapat 6 poin"
      };
    case "finished":
      return {
        image: FinishImage,
        title: "Latihanmu minggu ini udah selesai",
        desc: "Tunggu latihan selanjutnya, ya!",
        button: null,
        badge: null
      };
  }
};

export const PracticeCard: React.FC<PracticeCardProps> = ({
  practiceStatus,
  handleStartSession,
  onOpenHistory
}) => {
  if (!practiceStatus) {
    return (
      <PracticeCardWrapper>
        <LoadingContainer>
          <LoadingSpinner variant="ring" />
        </LoadingContainer>
      </PracticeCardWrapper>
    );
  }

  const content = cardContent(practiceStatus);

  return (
    <PracticeCardWrapper>
      <PracticeCardContent>
        <ContentImage src={content.image} alt={content.title} />
        <ContentText>
          <TextTitle>{content.title}</TextTitle>
          <TextDesc>{content.desc}</TextDesc>
        </ContentText>
      </PracticeCardContent>

      <ContentButtonGroup>
        {content.button && (
          <Button
            appearance="general"
            variant="primary"
            size={ButtonSize.lg}
            onClick={handleStartSession}
            isFullWidth
          >
            {content.button}
            <Icon name="navigation-arrow-right" />
          </Button>
        )}
        <Button
          appearance="general"
          variant="secondary"
          size={ButtonSize.lg}
          onClick={onOpenHistory}
          isFullWidth
        >
          Riwayat Latihan
        </Button>
        {content.badge && (
          <ContentBadge>
            <BadgeText>{content.badge}</BadgeText>
          </ContentBadge>
        )}
      </ContentButtonGroup>
    </PracticeCardWrapper>
  );
};
